import { Linking, Platform } from 'react-native';

/** Public website route. The version check opens this in a web frame. */
export const APP_UPDATE_ROUTE = '/update';

/** App Store listing for Vertiv Site Scope. Apple id 6751177173. */
export const IOS_APP_STORE_URL =
  'https://apps.apple.com/us/app/vertiv-site-scope/id6751177173';

/** Play listing for the production Android package. */
export const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.vertiv.its';

/** Packages that have their own Play listing. The phone opens its own. */
const ANDROID_STORE_PACKAGES = new Set([
  'com.vertiv.its',
  'com.vertiv.its.dev',
  'com.vertiv.its.qa',
  'com.vertiv.its.secure',
]);

/**
 * URL to open outside the update WebView, or null when the frame should load it.
 * Play links use the installed package so QA does not land on the other listing.
 */
export function externalStoreHandoff(
  url: string,
  bundleId: string,
): string | null {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  const host = parsed.hostname.toLowerCase();
  if (parsed.protocol === 'market:' || host === 'play.google.com') {
    if (!ANDROID_STORE_PACKAGES.has(bundleId)) {
      return null;
    }
    return `market://details?id=${bundleId}`;
  }
  if (host === 'apps.apple.com' || host === 'itunes.apple.com') {
    return url;
  }
  return null;
}

export function isAppUpdateRoute(pathname: string): boolean {
  return pathname.split('?')[0] === APP_UPDATE_ROUTE;
}

export function platformFromRoute(route: string): 'android' | 'ios' | null {
  const query = route.split('?')[1] ?? '';
  const platform = new URLSearchParams(query).get('platform');
  if (platform === 'android' || platform === 'ios') {
    return platform;
  }
  return null;
}

export function storeListingForPlatform(platform: 'android' | 'ios' | null): {
  url: string;
  label: string;
} {
  if (platform === 'android') {
    return {
      url: ANDROID_PLAY_STORE_URL,
      label: 'Get it on Google Play',
    };
  }
  return {
    url: IOS_APP_STORE_URL,
    label: 'Download on the App Store',
  };
}

export function openStoreListing(url: string): void {
  if (Platform.OS === 'web') {
    if (typeof window !== 'undefined' && window.location) {
      window.location.assign(url);
    }
    return;
  }
  void Linking.openURL(url);
}
